import React, { Component } from 'react';

export default class Loading extends Component {
    render() {
        return (
            <div className='loading'>Загрузка...</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js